import {ActionType} from "@src/store/ActionType";

export const GET_GRADUATES_AMOUNT = new ActionType("GET_GRADUATES_AMOUNT");